<div [class.black]="black">
    <div>
        <mat-icon [svgIcon]="black ? 'tip_black' : 'tip'"></mat-icon>
    </div>
    <span>{{ text }}</span>
</div>
